import { parseReportDateForSort } from "./reportDateSortUtils";

export const DAILY_SALE_FIXED_COLUMNS = 5;

/** Column index → API row field. Index 0 (#) is not sortable. */
export const DAILY_SALE_COLUMN_FIELDS = [
  null,
  "date",
  "voucher_type",
  "ref_no",
  "customer_name",
  "location_name",
  "qty",
  "grossSales",
  "hidden_discount",
  "total_Sales",
  "discount",
  "labour",
  "shipping",
  "subTotal",
  "taxAmount",
  "netSales",
  "credit_notes",
  "cash",
  "credit_amount",
  "bank",
  "balanceDue",
  "count",
  "loyality_points",
  "sales_person",
  "user",
  null,
];

const NUMERIC_FIELDS = new Set([
  "qty",
  "grossSales",
  "hidden_discount",
  "total_Sales",
  "discount",
  "labour",
  "shipping",
  "subTotal",
  "taxAmount",
  "netSales",
  "credit_notes",
  "cash",
  "credit_amount",
  "bank",
  "balanceDue",
  "count",
  "loyality_points",
]);

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (field === "date") return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortDailySaleRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = DAILY_SALE_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};

// direction comes from the header's Sort Ascending / Sort Descending menu; without it the
// column toggles.
export const getNextSortConfig = (current, columnIndex, direction) => {
  if (!columnIndex) return current;
  if (direction === "asc" || direction === "desc") return { columnIndex, direction };
  if (current?.columnIndex === columnIndex) {
    return {
      columnIndex,
      direction: current.direction === "asc" ? "desc" : "asc",
    };
  }
  return { columnIndex, direction: "asc" };
};
